import React from "react";
import { defineMessages } from "react-intl";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { OutlinedButton } from "../button/Buttons.js";
import "../button/EditButton.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { Icon, IconColor } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const localized = defineMessages({
  downloadTemplateActionTitle: {
    id: "downloadTemplateActionTitle",
    defaultMessage: "Excel Example"
  },
  downloadTemplateActionDescription: {
    id: "downloadTemplateActionDescription",
    defaultMessage: "You can download the attached example and use them as a starting point for your own file."
  },
  downloadTemplateActionButtonLabel: {
    id: "downloadTemplateActionButtonLabel",
    defaultMessage: "Download"
  }
});
const useClasses = makeStyles()((theme) => ({
  downloadTemplateActionContainer: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr",
    padding: theme.spacing(2.5),
    background: theme.palette.secondary.light,
    borderRadius: theme.custom.defaultBorderRadius * 5,
    marginTop: theme.spacing(3.75)
  },
  downloadTemplateActionTextBox: {
    color: theme.palette.secondary.main
  },
  downloadTemplateActionButtonBox: {
    display: "flex",
    justifyContent: "right",
    alignItems: "center"
  },
  downloadTemplateActionTitle: {
    fontWeight: 500,
    paddingBottom: theme.spacing(1.25)
  },
  downloadTemplateActionTitleIcon: {
    marginRight: theme.spacing(1.25),
    padding: theme.spacing(0.625),
    borderRadius: theme.custom.defaultBorderRadius * 1.25,
    backgroundColor: theme.custom.palette.status.lime.main
  },
  downloadTemplateActionButton: {
    fontWeight: 500
  }
}));
function DownloadTemplate({ title, onDownload: onClick }) {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(Box, { className: classes.downloadTemplateActionContainer }, /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Box, { className: classes.downloadTemplateActionTitle }, /* @__PURE__ */ React.createElement(
    Icon,
    {
      icon: CustomIcon.CheckList,
      color: IconColor.PrimaryContrastText,
      className: classes.downloadTemplateActionTitleIcon
    }
  ), /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.downloadTemplateActionTitle }), /* @__PURE__ */ React.createElement("span", null, " "), /* @__PURE__ */ React.createElement(LocalizedText, { label: title })), /* @__PURE__ */ React.createElement(Box, { className: classes.downloadTemplateActionTextBox }, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.downloadTemplateActionDescription }))), /* @__PURE__ */ React.createElement(Box, { className: classes.downloadTemplateActionButtonBox }, /* @__PURE__ */ React.createElement(OutlinedButton, { onClick, className: classes.downloadTemplateActionButton }, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.downloadTemplateActionButtonLabel }))));
}
export {
  DownloadTemplate
};
//# sourceMappingURL=DownloadTemplate.js.map
